<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="order?.branch?.company?.logo" :src="getFileServerUrl + order?.branch?.company?.logo" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                            <p v-if="order.branch?.company?.website" class="company-text">
                              <v-icon size="small">mdi-web</v-icon>
                              {{ order.branch?.company?.website || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">Proforma Invoice Details</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 13px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>INVOICE DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>SEASON</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.season || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Department</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(order.department) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>PROFORMA INVOICE NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.proforma_invoice_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>MASTER SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.master_sales_contact_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>PO NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ order.purchase_order_no }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>SUPPLIER:</strong><br/>
                              <strong>Name</strong> {{ order.branch?.company?.name || '-' }}<br/>
                              <strong>Address</strong> {{ order.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong>  {{ order.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong>  {{ order.branch?.company?.phone || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 8px;">
                              <strong>BUYER:</strong><br/>
                              <strong>Name:</strong> {{ order.buyer?.company_name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.buyer?.company_address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.buyer?.company_email || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: 170px; border: 1px solid #000; padding: 8px;">
                              <strong>BENEFICIARY:</strong><br/>
                              <strong>Name:</strong> {{ order.branch?.company?.name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong> {{ order.branch?.company?.phone || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: 170px; border: 1px solid #000; padding: 8px;">
                              <strong>BENEFICIARY'S BANK:</strong><br/>
                              <strong>Bank Name:</strong> {{ order.beneficiary_bank?.name || '-' }}<br/>
                              <strong>Bank Address:</strong> {{ order.beneficiary_bank?.address || '-' }}<br/>
                              <strong>Branch:</strong> {{ order.beneficiary_bank?.branch || '-' }}<br/>
                              <strong>Swift Code:</strong> {{ order.beneficiary_bank?.swift_code || '-' }}<br/>
                              <strong>A/C No:</strong> {{ order.beneficiary_bank?.account_no || '-' }}<br/>
                              <strong>A/C Name:</strong> {{ order.beneficiary_bank?.account_name || '-' }}<br/>
                              <strong>Routing No:</strong> {{ order.beneficiary_bank?.routing_no || '-' }}<br/>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Breakdown Table -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="dep-table order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 8px;">Order Number</th>
                            <th style="border: 1px solid #000; padding: 8px;">Style Number</th>
                            <th style="border: 1px solid #000; padding: 8px;">Description</th>
                            <th style="border: 1px solid #000; padding: 8px;">HS Code</th>
                            <th style="border: 1px solid #000; padding: 8px;">Composition</th>
                            <th style="border: 1px solid #000; padding: 8px;">Color Name</th>
                            <th style="border: 1px solid #000; padding: 8px;">Size Range</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Quantity</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Unit Price</th>
                            <th style="border: 1px solid #000; padding: 8px;">Currency</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">Total Amount</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 8px;">Cargo Receiving Date</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 8px;">ETD Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, i) in order.breakdowns" :key="row.id">
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.po }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.style_number }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.description }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.hs_code }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.composition }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.color_name }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.size_range }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.quantity }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.unit_price }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.currency?.code }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ row.total_amount }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ formatDate(row.cargo_receiving_date) }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ formatDate(row.etd_date) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Footer Table -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="footer-table order-table mt-4" style="width: 100%; border-collapse: collapse; font-size: 11px;">
                        <tbody>
                          <tr>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>From</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.shipment_from || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>TO</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.shipment_to || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Payment Terms</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.payment_terms || '-' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Shipment Mode</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.shipping_mode?.name || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Incoterm</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.incoterm || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Partial Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.partial_shipment || '-' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Inspection Certificate By</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.inspaction_certificate_by || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Short/Excess Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">+/- {{ order.short_or_excess_shipment_percent || '-' }}%</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Transhipment</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.transhipment || '-' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>LC Expiry Date</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.lc_expiry_date || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Port Of Loading</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.loading_port?.name || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Early Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.early_shipment || '-' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 4px; text-align: left;"><strong>Destination Of Loading</strong></th>
                            <td style="border: 1px solid #000; padding: 4px;">{{ order.destination_port?.name || '-' }}</td>
                            <td colspan="4" style="border: none;"></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Terms & Conditions -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 10px;">
                        <v-row>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 8px; min-height: 120px;">
                              <strong>TERM & CONDITION OF SHIPMENT:</strong><br/>
                              <div style="margin-top: 8px;">
                                {{ order.branch?.terms_and_condition || '-' }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 8px; min-height: 120px; text-align: center;">
                              <div style="margin-top: 40px; font-size: 13px; border-bottom: 1px solid #000; min-height: 30px;"></div>
                              <strong>SIGNATURE OF THE SUPPLIER:</strong><br/>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="order?.branch?.company?.footer_image" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const order = ref({
  branch: { company: {} },
  buyer: {},
  beneficiary_bank: {},
  buyer_bank: {},
  shipping_mode: {},
  breakdowns: [],
  proforma_invoice_no: "",
  invoice_date: null,
  code: "",
});

// File server URL
const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

// Format date
function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

// Total Quantity
const totalQuantity = computed(() =>
  order.value.breakdowns.reduce((sum, r) => sum + Number(r.quantity || 0), 0)
);

// Fetch data
async function fetchDetails(id) {
  try {
    const res = await store.dispatch("getProformaInvoiceById", { id });
    if (res?.data?.data) {
      order.value = res.data.data;

      // Convert breakdown dates
      order.value.breakdowns = order.value.breakdowns.map(row => ({
        ...row,
        cargo_receiving_date: row.cargo_receiving_date ? new Date(row.cargo_receiving_date) : null,
        etd_date: row.etd_date ? new Date(row.etd_date) : null
      }));
    }
  } catch (err) {
    console.error("Error fetching order details:", err);
  }
}

function print() {
  const printContent = document.getElementById("printable-area").innerHTML;
  const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Proforma Invoice</title>
    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      @page {
        size: A4;
        margin: 0;
        padding: 0;
      }

      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: auto;
      }

      body { 
        font-family:"Times New Roman", serif; 
        background:#fff; 
        color:#000; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
        margin: 0;
        padding: 0;
      }

      .report-paper { 
        width: 100%; 
        padding: 0 !important;
        background: #fff;
        margin: 0;
      }

      .invoice-container {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      .invoice-content {
        width: 100%;
        margin: 0;
        padding: 0;
        overflow: visible;
      }

      header img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 10;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      footer img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      .page-header {
        margin-bottom: 20px;
        padding: 20px 0;
      }

      .header-section { 
        display: flex; 
        justify-content: space-between; 
        align-items: flex-start; 
        border-bottom: 2px solid #eee; 
        padding-bottom: 10px; 
        margin-bottom: 16px; 
      }

      .company-name { 
        font-size: 20px; 
        font-weight: bold; 
        text-transform: uppercase; 
        margin: 0 0 4px 0; 
      }

      .company-text { 
        font-size: 14px; 
        margin: 2px 0; 
        display: flex; 
        align-items: center; 
      }

      .logo-container img { 
        max-height: 70px; 
        max-width: 150px; 
      }

      .report-title { 
        font-size: 20px; 
        text-align: center; 
        margin: 16px 0; 
      }

      .master-box {
        margin: 16px 0;
        font-size: 13px;
      }

      .watermark {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
      }

      table { 
        width: 100% !important; 
        border-collapse: collapse; 
        font-size: 13px; 
        margin: 8px 0;
        background: white;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      th, td { 
        border: 1px solid #000; 
        padding: 6px; 
        vertical-align: middle; 
      }

      th { 
        background: #e0e0e0; 
        text-align: center; 
        font-weight: bold;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .master-box-parent {
        border: none !important;
      }

      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .text-left { text-align: left; }
      .mt-4 { margin-top: 16px !important; }
      .mt-8 { margin-top: 40px !important; }
      .my-6 { margin-top: 24px !important; margin-bottom: 24px !important; }

      img { 
        max-width: 100% !important; 
        height: auto !important; 
      }

      .d-flex { display: flex; }
      .justify-space-between { justify-content: space-between; }
      .align-start { align-items: flex-start; }
      .v-row { 
        display: flex !important; 
        flex-wrap: wrap !important; 
        margin: 0;
        width: 100%;
      }

      .v-col-6 { 
        flex: 0 0 50% !important; 
        max-width: 50% !important; 
        padding: 12px;
        box-sizing: border-box;
      }

      .pa-6 { padding: 0 !important; }

      .order-table thead {
        display: table-header-group;
      }

      .order-table tbody tr {
        page-break-inside: avoid;
      }

      .signature-box {
        font-size: 11px;
        border: 1px solid black;
        border-radius: 5px;
        padding: 10px;
      }

      .signature-line {
        border-bottom: 1px solid #000;
        margin: 50px 0;
        height: 30px;
      }

      .signature-label {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 10px;
      }

      .invoice-container {
        display: flex;
        flex-direction: column;
      }

      .invoice-content {
        flex: 1;
        overflow: visible;
      }
        
      .company-info {
        flex: 1;
      }

      .invoice-footer {
        margin-top: auto;
        position: fixed;
        left; 0;
        bottom: 15px;
        width: 100%;    
      }

      @media print { 
        body {
          margin: 0;
          padding: 0;
        }

        .report-paper {
          margin: 0;
          padding: 0;
        }

        main {
          padding-top: 180px;
          padding-bottom: 150px;
          padding-left: 20px;
          padding-right: 20px;
        }

        .watermark {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
          
        .order-table {
          page-break-inside: auto;
        }

        .order-table tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        .order-table thead {
          display: table-header-group;
        }
      }
    </style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => printWindow.print(), 500);
}

onMounted(() => {
  const id = route.params.id;
  if (id) fetchDetails(id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 20px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 14px; }
.report-title { font-size: 20px; text-align: center; margin: 16px 0; }
.meta-box { border: 1px solid #000; padding: 8px; font-size: 13px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 6px; }
.dep-table th { background: #e0e0e0; }
.footer-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.footer-table th, .footer-table td { border: 1px solid #000; padding: 6px; }
.footer-table th { background: #fff; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
